import * as action_types from './actionTypes'
import {presistStoreState} from '../stores/reduxStore'
import {disconnectWebSocket, resetWebSocket} from '../utils/api/webSocket'

export const login = data => dispatch => {
  dispatch({
    type: action_types.USER_LOGGING_IN
  })

  dispatch({
    type: action_types.USER_LOGGED_IN,
    payload: {
      auth_token: data.auth_token, refresh_token: data.refresh_token,
      id: data.id, email: data.email, permissions: data.permissions, person_id: data.person_id
    }
  }, presistStoreState())
}

export const logout = () => dispatch => {
  dispatch({
    type: action_types.USER_LOGGED_OUT
  }, presistStoreState())

  disconnectWebSocket()
}

export const userRefreshToken = data => dispatch => {
  dispatch({
    type: action_types.USER_REFRESH_TOKEN,
    payload: data
  }, presistStoreState())

  resetWebSocket()
}



// WEBPACK FOOTER //
// ./src/actions/user.js